import { ApiInterface } from '@hidat/huijs-api';
import { NgApiInterface } from '../ng-http-api-interface';
import { CtApiModelTransformer } from './api-model-transformer';

/**
 * Http interface that uses Class Transfermer for Serialize/Deserialze (instead of JSONConvert)
 */
export class CtHttpApiInterface<T>
  extends NgApiInterface<T>
  implements ApiInterface<T>
{
  constructor(
    baseUrl: string,
    endpoint: string,
    protected jsonClass: any,
  ) {
    const transformer = new CtApiModelTransformer(jsonClass);
    super(transformer, baseUrl, endpoint);
  }
}
